import React, { useCallback } from 'react'
import RadioForm from './RadioForm'

import { RadioText } from './TextRadioForm.styles'
import { colors } from 'themes'

type IdText = {
	id: number,
	text: string
}

interface TextRadioFormProps {
	items: Array<IdText>,
	onSelected: (item: IdText) => any,
	selected: IdText,
}

export default function TextRadioForm(
	props: TextRadioFormProps,
) {

	return (
		<RadioForm<IdText>
			{...props}
			items={props.items}
			renderItem={({ item }) => (
				<RadioText>
					{item.text}
				</RadioText>
			)}
			keyExtractor={
				useCallback(
					({ id }) => id,
					[],
				)
			}
			getFade={
				useCallback(
					(item: IdText) => ({ width: '0', rightEndPercent: 0 }),
					[],
				)
			}
			onSelected={props.onSelected}
			selected={props.selected}
			background={colors.radioForm.defaultBackground}
			selectionBackground={colors.radioForm.defaultSelectedBackground}
		/>
	)
}
